import { Map } from 'immutable';
import _ from 'lodash';

import BaseStore from './BaseStore';
import Search from '../records/Search';
import SeasonSearch from '../records/SeasonSearch';
import DaySaveSearch from '../records/DaySaveSearch';
import RoversRangersSearch from '../records/RoversRangersSearch';
import PromoCode from '../records/PromoCode';
import { ActionTypes } from '../constants/AppConstants';

const searchTypes = new Map({
    'point': Search,
    'season': SeasonSearch,
    'daySave': DaySaveSearch,
    'roversRangers': RoversRangersSearch,
});

function _getDefaultState () {
    return searchTypes.map((Type) => new Type());
}

export class PreviousSearchesStore extends BaseStore {

    deserialize (serialized) {
        let state = _getDefaultState();

        if (serialized) {
            _.forEach(serialized, (value, key) => {
                if (state.has(key)) {
                    const SearchClass = searchTypes.get(key);
                    state = state.set(key, SearchClass.fromJSON(value));
                }
            });
        }

        return state;
    }

    get(type) {
        const SearchClass = searchTypes.get(type);
        return this.state.get(type, new SearchClass());
    }

    handleNewSearch (type, search) {
        this.setState(this.state.set(type, search));
    }

    handleNewPointSearch ({ search }) {
        this.handleNewSearch('point', search.set('submitted', true));
    }

    handleNewSeasonSearch ({ search }) {
        this.handleNewSearch('season', search.set('submitted', true));
    }

    handleNewDaySaveSearch ({ search }) {
        this.handleNewSearch('daySave', search);
    }

    handleNewRoversRangersSearch ({ search }) {
        this.handleNewSearch('roversRangers', search);
    }

    handlePromoCodeRemoved () {
        const emptyPromoCode = new PromoCode();
        let state = this.state;
        searchTypes.keySeq().forEach(type => {
            const search = state.get(type);
            if (search && search.get('promoCode')) {
                state = state.set(type, search.set('promoCode', emptyPromoCode));
            }
        });
        this.setState(state);
    }

    handleLoggedOut () {
        this.setState(new Map({
            point: new Search(),
            season: new SeasonSearch(),
            daySave: new DaySaveSearch(),
            roversRangers: new RoversRangersSearch()
        }));
    }

    getActionHandlers () {
        return {
            [ActionTypes.SEARCH_FAILED]: this.handleNewPointSearch,
            [ActionTypes.SEARCH_STARTED]: this.handleNewPointSearch,
            [ActionTypes.SEARCH_LOADED]: this.handleNewPointSearch,
            [ActionTypes.SEARCH_UPDATED]: this.handleNewPointSearch,
            [ActionTypes.SEASON_SEARCH_STARTED]: this.handleNewSeasonSearch,
            [ActionTypes.SEASON_SEARCH_LOADED]: this.handleNewSeasonSearch,
            [ActionTypes.SEASON_SEARCH_FAILED]: this.handleNewSeasonSearch,
            [ActionTypes.SEASON_SEARCH_UPDATED]: this.handleNewSeasonSearch,
            [ActionTypes.DAYSAVE_SEARCH_LOADED]: this.handleNewDaySaveSearch,
            [ActionTypes.DAYSAVE_SEARCH_STARTED]: this.handleNewDaySaveSearch,
            [ActionTypes.DAYSAVE_SEARCH_FAILED]: this.handleNewDaySaveSearch,
            [ActionTypes.ROVERSRANGERS_SEARCH_LOADED]: this.handleNewRoversRangersSearch,
            [ActionTypes.ROVERSRANGERS_SEARCH_STARTED]: this.handleNewRoversRangersSearch,
            [ActionTypes.ROVERSRANGERS_SEARCH_FAILED]: this.handleNewRoversRangersSearch,
            [ActionTypes.FARE_ONLY_SEARCH_STARTED]: this.handleNewPointSearch,
            [ActionTypes.FARE_ONLY_SEARCH_FAILED]: this.handleNewPointSearch,
            [ActionTypes.FARE_ONLY_SEASON_SEARCH_STARTED]: this.handleNewSeasonSearch,
            [ActionTypes.FARE_ONLY_SEASON_SEARCH_FAILED]: this.handleNewSeasonSearch,
            [ActionTypes.PROMOCODE_REMOVED]: this.handlePromoCodeRemoved,
            [ActionTypes.LOGGED_OUT]: this.handleLoggedOut
        };
    }
}

const instance = new PreviousSearchesStore({ storageKey: 'previous-searches' });

export default instance;
